// import { Swiper, EffectFade, Autoplay } from "swiper/dist/js/swiper.esm.js";
import Swiper, { EffectFade, Autoplay } from "swiper";

Swiper.use([EffectFade, Autoplay]);

export default class FaderSwiper {
  constructor() {
    this.fader = document.querySelectorAll(".jsFaderSlideshow");
    if (this.fader) this.init();
  }

  setFader(i, config) {
    new Swiper(i, config);
  }

  init() {
    for (let i = 0; i < this.fader.length; i++)
    {
      let config =
      {
        allowTouchMove: false,
        spaceBetween: 300,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        speed: 5000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
      };
      this.setFader(this.fader[i], config);
    }
  }
}
